<template>

<div class="prp-table-container">
    <h5>Resultados de Votos Emitidos para Boleta:</h5>
    <h1>{{ocg.ocg}}</h1>
<scale-loader
    class="prp-table-loader"
    v-if="loading"
    color="black"
></scale-loader>
<apexchart class="chart-pie" type="pie" width="70%" :options="chartOptions" :series="ocg.series"></apexchart>
<v-simple-table>
    <template v-slot:default>
        <thead>
        <tr>
            <th class="text-center">
                Total Votantes
            </th>
            <th class="text-center">
                Total Faltantes
            </th>
            <th class="text-center">
                Padron de Eleccion
            </th>
            <th>
                Porcentaje de Votos
            </th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>{{ ocg.votosemitidos }}</td>
            <td>{{ ocg.faltan }}</td>
            <td>{{ ocg.total }}</td>
            <td>{{ ocg.porcentaje }}%</td>
        </tr>
        </tbody>
    </template>
</v-simple-table>
</div></template>

<script>

import ScaleLoader from 'vue-spinner/src/ScaleLoader';
import VueApexCharts from 'vue-apexcharts';

export default {
    name: 'votesEmitted',
    props: ['ocg'],
    components: {
        ScaleLoader,
        apexchart: VueApexCharts,
    },

    data: () => ({
        loading:false,
        chartOptions: {
            chart: {
                width: 380,
                type: 'pie',
            },
            colors : ['#2E93fA','#90BBD8'],
            labels : ['Votantes','Faltantes'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    }),
    methods: {
        loadOptions: function() {
            let colors1 = ['#2E93fA','#6DB3FB','#ADD4FD','#79BABF','#86C0FC','#66D8F8' ];
            let colors2 = ['#90BBD8','#E0EDFf5','#4D8EBA','#F2F7FB','#377EAF','#D8EEF2'];
            let color1 = colors1[Math.floor(Math.random() * colors1.length)];
            let color2 =  colors2[Math.floor(Math.random() * colors2.length)];
            //this.chartOptions.colors = [color1,color2];
            //this.chartOptions.labels = ['Votantes','Faltantes'];
        },
    },

    created() {
        this.loadOptions();
    },

}

</script>
